// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1Nl2b","error":"Textarea_error__2xrHH","readonly":"Textarea_readonly__3YS_Z","disabled":"Textarea_disabled__3T69T"};